import styled, { css } from 'styled-components/macro';

import { RemoteImage } from 'components/RemoteImage';
import { ReactComponent as CalendarSvg } from 'components/svg/Calendar.svg';
import { large, medium } from 'styles/breakpoints';
import { container } from 'styles/layout';
import { heading, input, paragraph } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const Container = styled.div`
  ${container}

  margin: 16px auto 0;
`;

export const Header = styled.h1`
  ${heading}

  margin: 26px 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;

export const SummaryDetails = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 0 35px;

  ${large`
    margin-left: 115px;
  `}
`;

export const SummaryItems = styled.div`
  list-style: none;
  max-width: 290px;
  padding: 0 14px;
  text-align: left;

  ${large`
    padding: 0;
  `}
`;

export const SummaryItem = styled.p`
  ${input}

  align-items: center;
  display: flex;
  line-height: 24px;
  margin: 20px 0 14px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}

  ${large`
    margin-top: 11px;
  `}
`;

export const SummaryImage = styled(CalendarSvg)`
  height: 24px;
  margin-right: 10px;
  width: 21px;
`;

export const SalesPerson = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;

  ${large`
    margin-left: -109px;
    /* Fixes IE 11 issue where text would not wrap */
    width: 374px;
  `}
`;

const faceStyles = css`
  border-radius: 100%;
  flex: 1 0 auto;
  height: 74px;
  margin: 0 13px 0 0;
  width: 74px;

  ${medium`
    height: 96px;
    width: 96px;
  `}
`;

export const FaceRemote = styled(RemoteImage)`
  ${faceStyles}
`;

export const FaceUnknown = styled.img`
  ${faceStyles}
`;

export const Description = styled.p`
  ${paragraph}

  flex: 1 1 auto;
  margin: 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}

  > span > b {
    text-transform: uppercase;
  }
`;

export const Note = styled.p`
  ${paragraph}

  font-style: italic;
  margin: 30px 0 0;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;
